export default {
  methods: {
    close() {
      this.$el.classList.add('fadeOut')
      setTimeout(() => {
        this.$el.parentNode.removeChild(this.$el)
      }, 300)
    }
  }
}